import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { EMPTY, Observable, of } from "rxjs";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { ToastHandlerService } from './../other/tostHandler.service';
import { L10nTranslationService } from 'angular-l10n';
import { ToastMessageSeverity } from "../../enums/toastMessageTypes.enum";
import { MaintenanceMode } from "../../models/maintenanceMode.model";
import { AppConstants } from "src/app/app.constants";

@Injectable({
  providedIn: "root"
})
export class MaintenanceModeService {
  public maintenanceMode: MaintenanceMode = new MaintenanceMode();
  public isMaintenanceModeActive: boolean = false;

  constructor(
    private _http: HttpClient,
    private _router: Router,
    private _toastService: ToastHandlerService,
    private _translationService: L10nTranslationService
  ) {
    this.getMaintenanceMode().subscribe(() => EMPTY);
  }

  public getMaintenanceMode(): Observable<any> {
    return this._http.get<any>(AppConstants.SDB_MAINTENANCE_MODE)
      .pipe(
        map((response) => {
          const now = new Date().getTime();
          const result = (response.result as MaintenanceMode);
          if (
            result.active &&
            (!!result.startDate && result.startDate < now) &&
            (!!result.endDate && result.endDate > now)
          ) {
            this.isMaintenanceModeActive = true;
            this._router.navigate(["maintenanceMode"]);
          }
          this.maintenanceMode = result;
          return response
        }),
        catchError((err) => {
          console.log(err);
          this._toastService.showMessage(
            ToastMessageSeverity.error,
            this._translationService.translate('CARRIERDB.EXCEPTION.GENERAL'),
            this._translationService.translate(
              'CARRIERDB.EXCEPTION.MESSAGE_SUPPORT'
            )
          );
          return of(null);
        })
      );
  }
}
